module.exports = __webpack_public_path__ + "img/_netherlands.ce8ae1d9.png";